(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draws-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draws-utils.js');

'use strict';

const drawsSingleton = svs.numbergames.draws.internal.getDrawsSingleton();
const {
  productMapping
} = svs.numbergames;
const {
  isToday,
  isTomorrow,
  differenceInCalendarDays
} = dateFns;
const {
  FormatTime: formatTime
} = svs.utils.date;
const todayOrTomorrow = date => {
  date = new Date(date);
  if (isToday(date)) {
    return 'idag';
  }
  if (isTomorrow(date)) {
    return 'imorgon';
  }
  return '';
};
const dayOfWeek = date => formatTime('EEEE', date);
const dateAndMonth = date => formatTime('d/M', date);
const daysFromNow = date => differenceInCalendarDays(new Date(date), new Date());
const sortByWeekday = (d1, d2) => new Date(d1.first).getDay() - new Date(d2.first).getDay();
const getFromToStr = arr => {
  const dates = arr.flatMap(_ref => {
    let {
      first,
      last
    } = _ref;
    return [first, last];
  });
  const firstDate = dateAndMonth(dateFns.min(dates));
  const lastDate = dateAndMonth(dateFns.max(dates));
  return "".concat(firstDate, " - ").concat(lastDate);
};
const getMultipleDaysStr = (drawCount, firstAndLastDrawDates) => {
  switch (drawCount) {
    case 'subscription':
      return firstAndLastDrawDates.map(_ref2 => {
        let {
          weekday
        } = _ref2;
        return "".concat(weekday, "ar");
      }).join(' och ');
    case '1':
      return firstAndLastDrawDates.map(_ref3 => {
        let {
          first
        } = _ref3;
        return "".concat(dayOfWeek(first), " ").concat(dateAndMonth(first));
      }).join(', ');
    default:
      return "".concat(firstAndLastDrawDates.map(_ref4 => {
        let {
          first
        } = _ref4;
        return "".concat(dayOfWeek(first), "ar");
      }).join(' och '), " ").concat(getFromToStr(firstAndLastDrawDates));
  }
};
const calcLastDrawDate = (draw, drawCount) => {
  const daysBetweenDraws = productMapping.isDaily(draw.productItsId) ? 1 : 7;
  const date = new Date(draw.regCloseTime);
  date.setDate(date.getDate() + (drawCount - 1) * daysBetweenDraws);
  return date;
};
function firstDrawDate(draws) {
  const closeTimes = Object.values(draws).map(draw => new Date(draw.regCloseTime));
  return dateFns.min(closeTimes);
}
function lastDrawDate(draws) {
  let {
    drawCount = 1
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const closeTimes = Object.values(draws).map(draw => calcLastDrawDate(draw, drawCount));
  return dateFns.max(closeTimes);
}
function drawDayLabels(draws, _ref5) {
  let {
    drawCount
  } = _ref5;
  const formatFirstDrawDate = regCloseTime => {
    const dateString = formatTime('EEE d/M', regCloseTime);
    return dateString.charAt(0).toUpperCase() + dateString.slice(1);
  };
  return Object.fromEntries(Object.entries(draws).map(_ref6 => {
    let [productItsId, draw] = _ref6;
    if (!draw) {
      return [productItsId, productMapping.getDay(productItsId)];
    }
    switch (drawCount) {
      case 'subscription':
        return [productItsId, productMapping.getDay(productItsId)];
      case '1':
        return [productItsId, formatFirstDrawDate(draw.regCloseTime)];
      default:
        return [productItsId, "".concat(formatFirstDrawDate(draw.regCloseTime), " - ").concat(formatTime('d/M', calcLastDrawDate(draw, drawCount)))];
    }
  }));
}
function drawDateText(draws, _ref7) {
  var _selectedDays$;
  let {
    productId,
    drawCount,
    selectedDays = []
  } = _ref7;
  if (!Object.values(draws).filter(draw => Boolean(draw)).length) {
    return '';
  }
  if (productMapping.isProductFamily(productId) && !selectedDays.length) {
    return '';
  }
  const futureDrawDate = productItsId => {
    const draw = {
      [productItsId]: draws[productItsId]
    };
    return {
      weekday: productMapping.getDay(productItsId),
      first: firstDrawDate(draw),
      last: lastDrawDate(draw, {
        drawCount
      })
    };
  };
  if (selectedDays.length > 1) {
    const firstAndLastDrawDates = selectedDays.map(productItsId => futureDrawDate(productItsId)).sort(sortByWeekday);
    return "Speldagar: ".concat(getMultipleDaysStr(drawCount, firstAndLastDrawDates));
  }
  const productItsId = (_selectedDays$ = selectedDays[0]) !== null && _selectedDays$ !== void 0 ? _selectedDays$ : productMapping.getProductItsId(productId);
  const {
    first,
    last,
    weekday
  } = futureDrawDate(productItsId);
  const daysToStart = daysFromNow(first);
  let prefix;
  let drawDates;
  switch (drawCount) {
    case 'subscription':
      prefix = 'Speldag';
      drawDates = "".concat(weekday, "ar");
      break;
    case '1':
      prefix = 'Speldag';
      if (daysToStart < 2) {
        drawDates = "".concat(todayOrTomorrow(first));
      } else if (daysToStart >= 7 && daysToStart < 14) {
        drawDates = "n\xE4sta ".concat(dayOfWeek(first), " ").concat(dateAndMonth(first));
      } else {
        drawDates = "".concat(dayOfWeek(first), " ").concat(dateAndMonth(first));
      }
      break;
    default:
      prefix = 'Speldagar';
      if (daysToStart < 2) {
        drawDates = "".concat(todayOrTomorrow(first), " - ").concat(dateAndMonth(last));
      } else {
        drawDates = "".concat(dayOfWeek(first), "ar ").concat(dateAndMonth(first), " - ").concat(dateAndMonth(last));
      }
  }
  return "".concat(prefix, ": ").concat(drawDates);
}
function sortProductsByDrawTime(draws) {
  return Object.values(draws).sort((d1, d2) => new Date(d1.regCloseTime) - new Date(d2.regCloseTime));
}
const utilsApi = {
  firstDrawDate,
  lastDrawDate,
  drawDateText,
  drawDayLabels,
  sortProductsByDrawTime
};
Object.entries(utilsApi).forEach(_ref8 => {
  let [key, value] = _ref8;
  svs.numbergames.draws.drawsUtils[key] = (products, options) => value(drawsSingleton.findFirstPlayableDraw(products), options);
  svs.numbergames.draws.asyncDrawsUtils[key] = async (products, options) => value(await drawsSingleton.getFirstPlayableDraw(products), options);
});

 })(window);